// Configurações da aplicação
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Outras configurações podem ser adicionadas aqui
export const APP_VERSION = '1.0.0';
